import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListPotentialDamages } from "../../../components/Admin/PotentialDamages/ListPotentialDamages/ListPotentialDamages";
import { useLanguage } from "../../../contexts";
import "./PotentialDamages.scss";

export function PotentialDamages() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("actives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListPotentialDamages active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListPotentialDamages active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="potential-damages-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="potential-damages-page-header-wrapper">
        <div className="potential-damages-page-header">
          <span className="potential-damages-page-title">{t("potential_damages")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
